export default { Loading: '正在加载' };
